<template>
  <v-form
    :data="form"
    method="patch"
    format="formData"
    :url="$laravel.route('api.account.update')"
    @success="next()"
  >
    <d-card-row>
      <v-driving-licence :user="$laravel.user" />
    </d-card-row>

    <d-card-row>
      <div class="is-flex is-justify-content-flex-end">
        <button class="button is-primary">
          <span>{{ $t('next') }}</span>
          <span class="icon">
            <i class="mdi mdi-arrow-right" />
          </span>
        </button>
      </div>
    </d-card-row>
  </v-form>
</template>

<script>

import drivingLicenceVue from "@/shared/views/account/fieldsets/drivingLicence.vue";
import { fillFields } from "@/services/helpers";
import Step from "./step";

export default {
  components: {
    "v-driving-licence": drivingLicenceVue
  },
  extends: Step,
  data () {
    return {
      form: {
        driving_licence_number: null,
        driving_licence_expiry_date: null,
        driving_licence_picture_upload: null,
        _scenarios: [Registration.scenario]
      },
    };
  },
  created () {
    this.form = fillFields(this.form, this.$laravel.user);
  }
};
</script>
